import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  ContainerPrincipal,
} from './ClientesEmDebitoStyles';

function ClientesEmDebitoComponent() {
  return (
    <ContainerPrincipal>
      <p>Aguarde!  Opção em desenvolvimento</p>
    </ContainerPrincipal>
  );
}

export const ClientesEmDebito = withRouter(ClientesEmDebitoComponent);
